export enum EDrawerType {
  Edit = 'edit',
  AddNew = 'addNew',
  Duplicate = 'duplicate',
}
